import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import styles from "./leftNav.module.css";
import {useAppGlobalConfig} from "../../providers/AppGlobalConfigContext";
import {useLessonPlaybackState} from "../../hooks/useLessonPlaybackState";

const LeftNav = ({ usageTracker, data }) => {

  const {reset : forceLessonStop} = useLessonPlaybackState();

  const {isEmbedMode} = useAppGlobalConfig();

  const history = useHistory();
  const { catchupId, lessonId, block } = data[1];
  const listRef = useRef([]);

  const blockClasses = (blockId) => {
    let classList = `${styles.listGroupItem}`;
    if (blockId == block) {
      classList += ` ${styles.listGroupItemActive}`;
    } else if (usageTracker !== null) {
      if (usageTracker.progress.includes(blockId)) {
        classList += ` ${styles.listGroupItemCompleted}`;
      } else {
        classList += ` ${styles.listGroupItemBlocked}`;
      }
    } else {
      classList += ` ${styles.listGroupItemBlocked}`;
    }
    return classList;
  };

  const handleNavigation = (blockId, className) => {
    if (className.includes(styles.listGroupItemCompleted)) {
      forceLessonStop();
      history.push(`${isEmbedMode ? '/embeddable' : ''}/catchupId/${catchupId}/lesson/${lessonId}/${blockId}`);
    }
  };

  useEffect(() => {
    if (listRef.current[block]) {
      listRef.current[block].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [block]);

  return (
    <div className={isEmbedMode ? styles.leftNavBarEmbedded : styles.leftNavBar}>
      <div className={isEmbedMode ? styles.leftNavEmbedded : styles.leftNav}>
        <div className={styles.cardBody}>
          <div>
            <ul className={styles.listGroup}>
              {data[0].map((res, index) => {
                let blockId = index;
                let className = blockClasses(blockId);
                return (
                  <li key={index} className={styles.liStyle}>
                    <div
                      ref={(el) => (listRef.current[blockId] = el)}
                      onClick={() => handleNavigation(blockId, className)}
                      className={className}
                    >
                      <span className={styles.navCounter}>{index}</span>
                    </div>
                    <span className={styles.navText}> {res.section}</span>
                    <span className={styles.navText}> {res.subSection}</span>
                    <div className={styles.vl} />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftNav;
